import React, { useEffect } from 'react';
import { useCart } from '../../../context/CartContext';
import MultiPayButton from '../payButton/MultiPayButton';
import './CartDrawer.css';
import { calculatePlatformFee } from '../../../utils/api/platformFee';

export const CartDrawer = ({ isOpen, onClose, userId }) => {
  const { cartItems, removeFromCart, updateCartItemQuantity, clearCart, getCartTotal } = useCart();
  const [showBreakdown, setShowBreakdown] = React.useState(false);
  
  const getBreakdown = () => {
    return cartItems.reduce((acc, item) => {
      acc.tickets += item.ticketPrice * item.ticketsCount;
      acc.fees += calculatePlatformFee( item.ticketPrice * item.ticketsCount);
      return acc;
    }, { tickets: 0, fees: 0 });
  };

  const breakdown = getBreakdown();

  // Prevent scrolling when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="cart-drawer-overlay" onClick={onClose}>
      <div className={`cart-drawer ${isOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="cart-drawer-header">
          <h2 className="heading-7" style={{ margin: 0 }}>My Hobi Basket ({cartItems.length})</h2>
          <button className="close-drawer-btn" onClick={onClose}>×</button>
        </div>

        <div className="cart-drawer-content">
          {cartItems.length === 0 ? (
            <div className="empty-cart-message">
              <span style={{ fontSize: '48px', marginBottom: '15px' }}>🛒</span>
              <p>Your basket is empty</p>
              <button 
                onClick={onClose}
                className="button-3 w-button"
                style={{ marginTop: '20px' }}
              >
                Go Back
              </button>
            </div>
          ) : (
            <>
              <div className="cart-items-list-drawer">
                {cartItems.map((item, idx) => {
                  const available = item.eventData?.ticket_availability?.find(t => t.ticketName === item.ticketName)?.available || 10;
                  
                  return (
                    <div key={idx} className="cart-item-drawer">
                      <div className="cart-item-info">
                        <div className="cart-item-event">{item.eventName}</div>
                        <div className="cart-item-ticket">{item.ticketName}</div>
                        <div className="cart-drawer-quantity-selector">
                          <button 
                            onClick={() => updateCartItemQuantity(item.eventId, item.ticketId, Math.max(1, item.ticketsCount - 1), item.targetMonth || null)}
                            disabled={item.ticketsCount <= 1}
                          >-</button>
                          <span>{item.ticketsCount}</span>
                          <button 
                            onClick={() => updateCartItemQuantity(item.eventId, item.ticketId, Math.min(available, item.ticketsCount + 1), item.targetMonth || null)}
                            disabled={item.ticketsCount >= available}
                          >+</button>
                        </div>
                      </div>
                      <div className="cart-item-actions">

                        <div className="cart-item-price">₹{(item.ticketPrice * item.ticketsCount + calculatePlatformFee(item.ticketPrice * item.ticketsCount)).toFixed(2)}</div>
                        
                        <div className="" style={{ fontSize: '12px', color: '#666'}}>+ 18% GST</div>

                        <button 
                          className="remove-item-btn"
                            onClick={() => removeFromCart(item.eventId, item.ticketId, item.targetMonth || null)}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="cart-drawer-footer">
                <div className="cart-total-row" style={{ cursor: 'pointer', userSelect: 'none', marginBottom: '15px' }} onClick={() => setShowBreakdown(!showBreakdown)}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '14px', color: '#666' }}>
                    View Detailed Breakdown
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="12" 
                      height="12" 
                      fill="currentColor" 
                      viewBox="0 0 16 16"
                      style={{ transform: showBreakdown ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
                    >
                      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                    </svg>
                  </span>
                </div>

                {showBreakdown && (
                  <div className="payment-breakdown-details" style={{ padding: '10px 0', borderTop: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0', marginBottom: '15px', animation: 'fadeIn 0.3s ease' }}>
                    <div className="cart-total-row" style={{ fontSize: '14px', marginBottom: '8px' }}>
                      <span>Ticket(s) Price</span>
                      <span>₹{breakdown.tickets.toFixed(2)}</span>
                    </div>
                    <div className="cart-total-row" style={{ fontSize: '14px', marginBottom: '0' }}>
                      <span>Total Platform Fee</span>
                      <span>₹{breakdown.fees.toFixed(2)}</span>
                    </div>
                  </div>
                )}

                <div className="cart-total-row grand-total">
                  <span>Total Amount</span>
                  <span>₹{getCartTotal().toFixed(2)}</span>
                </div>
                
                <MultiPayButton 
                  userId={userId}
                  cartItems={cartItems}
                  totalAmount={getCartTotal().toFixed(2)}
                  onBookingSuccess={() => {
                    clearCart();
                    onClose();
                  }}
                />
                
                <button 
                  className="clear-all-btn"
                  onClick={clearCart}
                >
                  Clear All
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
